import React from 'react';
import { sortByNumericThenAlpha } from '@awp/helpers/sorter';
import Authorize from '@components/Authorize';
import { ENTITY_TITLES, Permissions } from '@awp/constants';
import { ActionMenuDelete } from '@components/Common/AwpActionMenus';
import { Button, Col, FormLabel, Row } from 'react-bootstrap';
import { FormSelect, FormTreeSelect } from '@components/Common/AwpFormInputs';
import Table from '@components/table';
import * as Yup from 'yup';
import { CrudService } from '@awp/shared/CrudService';

export class HazardForecastTemplateService extends CrudService {
  constructor(mode) {
    const entityName = ENTITY_TITLES.HAZARD_FORECAST_TEMPLATES;
    const entityPluralName = ENTITY_TITLES.HAZARD_FORECAST_TEMPLATES;

    super({ entityName, entityPluralName, mode });
  }

  static mapInitialValues(entity) {
    return {
      ...entity,
    };
  }

  static getValidations({ selectedAvalancheArea }) {
    return Yup.object({
      avalancheProgram: Yup.object().nullable().optional(),
      area: Yup.object()
        .nullable()
        .test('area', 'Area is a required field', () => {
          return selectedAvalancheArea?.length > 0;
        }),
      unassociatedWeatherStations: Yup.object().nullable().optional(),
    });
  }

  static getFields({
    avalanchePrograms,
    avalancheAreas,
    onProgramChange,
    onAreaChange,
    selectedAvalancheArea,
    selectedWeatherStations,
    associatedWeatherStations,
    unassociatedWeatherStations,
    onWeatherStationChange,
    onClickDelete,
    onClickAdd,
  }) {
    return (
      <>
        <Row>
          <Col className="mb-4">
            <FormSelect
              label="Avalanche Program"
              id="avalancheProgram"
              name="avalancheProgram"
              readOnly={false}
              isMulti={false}
              options={avalanchePrograms}
              isClearable={true}
              placeholder={'Select ...'}
              postChange={(e) => {
                onProgramChange(e);
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col className="mb-4">
            <FormTreeSelect
              className="show-selected-item-yes"
              readOnly={false}
              name="area"
              id="area"
              label="Area"
              options={avalancheAreas}
              onChange={(currentNode, selectedNodes) => {
                onAreaChange(avalancheAreas, selectedNodes);
              }}
            />
          </Col>
        </Row>
        <Authorize requires={[Permissions.WriteAdminTools]}>
          <Row>
            <Col className="mb-4">
              <FormSelect
                label="Weather Stations"
                id="unassociatedWeatherStations"
                name="unassociatedWeatherStations"
                readOnly={false}
                isMulti={true}
                isDisabled={selectedAvalancheArea?.length === 0 || !selectedAvalancheArea}
                options={unassociatedWeatherStations}
                getOptionLabel={(option) => option.DropdownText}
                getOptionValue={(option) => option.Id}
                isClearable={true}
                placeholder={'Select ...'}
                postChange={(e) => {
                  onWeatherStationChange(e);
                }}
              />
            </Col>
            <Col>
              <Button
                style={{ marginTop: '40px' }}
                disabled={selectedAvalancheArea?.length === 0 || selectedWeatherStations?.length === 0}
                onClick={() => {
                  onClickAdd();
                }}
              >
                Add
              </Button>
            </Col>
          </Row>
        </Authorize>
        <Row>
          <Col className="mb-4">
            <FormLabel>
              <strong>Associated Weather Stations</strong>
            </FormLabel>
            <Table
              columns={this.getColumns(onClickDelete)}
              data={associatedWeatherStations ?? []}
              fetchData={() => {}}
              defaultSortBy="code"
            />
          </Col>
        </Row>
      </>
    );
  }

  static getColumns(onClickDelete) {
    return [
      { Header: 'Name', accessor: 'Name', sortType: sortByNumericThenAlpha },
      { Header: 'Number', accessor: 'Number', sortType: sortByNumericThenAlpha },
      {
        Header: 'Actions',
        accessor: 'Id',
        disableSortBy: true,
        Cell: ({ row }) => {
          return this.getActionMenu(row, onClickDelete);
        },
      },
    ];
  }

  static getActionMenu(row, onClickDelete) {
    return (
      <>
        <div>
          <Authorize requires={[Permissions.WriteAdminTools]}>
            <ActionMenuDelete
              onClick={() => {
                onClickDelete(row.values.Id);
              }}
            />
          </Authorize>
        </div>
      </>
    );
  }
}
